import i18n from 'i18next';

export const filtersMeta = [
  {
    name: 'patientName',
    displayName: i18n.t('StudyList:PatientName'),
    inputType: 'Text',
    isSortable: true,
    gridCol: 4,
  },
  {
    name: 'mrn',
    displayName: i18n.t('StudyList:MRN'),
    inputType: 'Text',
    isSortable: true,
    gridCol: 2,
  },
  {
    name: 'patientAge',
    displayName: i18n.t('StudyList:PatientAge'),
    inputType: 'Text',
    isSortable: false,
    gridCol: 2,
  },
  {
    name: 'patientSex',
    displayName: i18n.t('StudyList:PatientSex'),
    inputType: 'Text',
    isSortable: false,
    gridCol: 2,
  },
  {
    name: 'accession',
    displayName: i18n.t('StudyList:AccessionNumber'),
    inputType: 'Text',
    isSortable: true,
    gridCol: 2,
  },
   {
    name: 'institutionName',
    displayName: i18n.t('StudyList:InstitutionName'),
    inputType: 'Text',
    isSortable: true,
    gridCol: 3,
  },
  {
    name: 'studyDate',
    displayName: i18n.t('StudyList:StudyDate'),
    inputType: 'DateRange',
    isSortable: true,
    gridCol: 3,
  },
  {
    name: 'description',
    displayName: i18n.t('StudyList:Description'),
    inputType: 'Text',
    isSortable: true,
    gridCol: 3,
  },
  {
    name: 'modalities',
    displayName: i18n.t('StudyList:Modality'),
    inputType: 'MultiSelect',
    inputProps: {
      options: [
        { value: 'BMD', label: 'BMD' },
        { value: 'CR', label: 'CR' },
        { value: 'CT', label: 'CT' },
        { value: 'DX', label: 'DX' },
        { value: 'MG', label: 'MG' },
        { value: 'OT', label: 'OT' },
        // { value: 'AR', label: 'AR' },
        // { value: 'ASMT', label: 'ASMT' },
        // { value: 'AU', label: 'AU' },
        // { value: 'BDUS', label: 'BDUS' },
        // { value: 'BI', label: 'BI' },
        // { value: 'CTPROTOCOL', label: 'CTPROTOCOL' },
        // { value: 'DG', label: 'DG' },
        // { value: 'DOC', label: 'DOC' },
        // { value: 'ECG', label: 'ECG' },
        // { value: 'EPS', label: 'EPS' },
        // { value: 'ES', label: 'ES' },
        // { value: 'FID', label: 'FID' },
        // { value: 'GM', label: 'GM' },
        // { value: 'HC', label: 'HC' },
        // { value: 'HD', label: 'HD' },
        // { value: 'IO', label: 'IO' },
        // { value: 'IOL', label: 'IOL' },
        // { value: 'IVOCT', label: 'IVOCT' },
        // { value: 'IVUS', label: 'IVUS' },
        // { value: 'KER', label: 'KER' },
        // { value: 'KO', label: 'KO' },
        // { value: 'LEN', label: 'LEN' },
        // { value: 'LS', label: 'LS' },
        // { value: 'MR', label: 'MR' },
        // { value: 'M3D', label: 'M3D' },
        // { value: 'NM', label: 'NM' },
        // { value: 'OAM', label: 'OAM' },
        // { value: 'OCT', label: 'OCT' },
        // { value: 'OP', label: 'OP' },
        // { value: 'OPM', label: 'OPM' },
        // { value: 'OPT', label: 'OPT' },
        // { value: 'OPTBSV', label: 'OPTBSV' },
        // { value: 'OPTENF', label: 'OPTENF' },
        // { value: 'OPV', label: 'OPV' },
        // { value: 'OSS', label: 'OSS' },
        // { value: 'PLAN', label: 'PLAN' },
        // { value: 'PR', label: 'PR' },
        // { value: 'PT', label: 'PT' },
        // { value: 'PX', label: 'PX' },
        // { value: 'REG', label: 'REG' },
        // { value: 'RESP', label: 'RESP' },
        // { value: 'RF', label: 'RF' },
        // { value: 'RG', label: 'RG' },
        // { value: 'RTDOSE', label: 'RTDOSE' },
        // { value: 'RTIMAGE', label: 'RTIMAGE' },
        // { value: 'RTINTENT', label: 'RTINTENT' },
        // { value: 'RTPLAN', label: 'RTPLAN' },
        // { value: 'RTRAD', label: 'RTRAD' },
        // { value: 'RTRECORD', label: 'RTRECORD' },
        // { value: 'RTSEGANN', label: 'RTSEGANN' },
        // { value: 'RTSTRUCT', label: 'RTSTRUCT' },
        // { value: 'RWV', label: 'RWV' },
        // { value: 'SEG', label: 'SEG' },
        // { value: 'SM', label: 'SM' },
        // { value: 'SMR', label: 'SMR' },
        // { value: 'SR', label: 'SR' },
        // { value: 'SRF', label: 'SRF' },
        // { value: 'STAIN', label: 'STAIN' },
        // { value: 'TEXTUREMAP', label: 'TEXTUREMAP' },
        // { value: 'TG', label: 'TG' },
        // { value: 'US', label: 'US' },
        // { value: 'VA', label: 'VA' },
        // { value: 'XA', label: 'XA' },
        // { value: 'XC', label: 'XC' },
      ],
    },
    isSortable: true,
    gridCol: 2,
  },
  {
    name: 'bodyPart',
    displayName: i18n.t('StudyList:BodyPart'),
    inputType: 'Text',
    isSortable: false,
    gridCol: 3,
  },
  {
    name: 'jobStatus',
    displayName: i18n.t('StudyList:Status'),
    isSortable: false,
    inputType: 'MultiSelect',
    inputProps: {
      options: [
        { value: 'Viewer OK', label: i18n.t('Common:Status Viewer OK') },
        { value: 'Aprovado', label: i18n.t('Common:Status Aprovado') },
        { value: 'Não visualizado', label: i18n.t('Common:Status Não visualizado') },
        { value: 'Processing', label: i18n.t('Common:Status Processing') },
        { value: 'Reported Success', label: i18n.t('Common:Status Reported Success') },
        { value: 'Reported Error', label: i18n.t('Common:Status Reported Error') },
        { value: 'Finished', label: i18n.t('Common:Status Finished') },
        { value: 'Failed', label: i18n.t('Common:Status Failed') },
        { value: 'Invalid file', label: i18n.t('Common:Status Invalid file') },
      ],
    },
    gridCol: 3,
  },
  {
    name: 'instances',
    displayName: i18n.t('StudyList:Instances'),
    inputType: 'None',
    isSortable: false,
    gridCol: 2,
  },
];

export const WORKLIST_COLUMNS_KEY = 'worklist_columns';

export const DEFAULT_WORKLIST_COLUMNS = [
  'patientName',
  'accession',
  'institutionName',
  'studyDate',
  'description',
  'modalities',
  'jobStatus',
  'instances',
];

export const MANDATORY_WORKLIST_COLUMNS = [
  'patientName',
  'studyDate',
  'jobStatus',
  'instances',
];

export function adjustGridCols(columns) {
  if (!columns || !columns.length) return [];
  const total = columns.reduce((acc, col) => acc + (col.gridCol || 3), 0);
  if (total === 24) return columns;

  const items = columns.map(col => {
    const exact = ((col.gridCol || 3) / total) * 24;
    const rounded = Math.max(1, Math.round(exact));
    return {
      ...col,
      gridCol: rounded,
      error: rounded - exact,
    };
  });

  let distributed = items.reduce((acc, item) => acc + item.gridCol, 0);
  let diff = 24 - distributed;

  if (diff > 0) {
    // Distribute remaining units to columns rounded down the most
    const sorted = [...items]
      .map((item, idx) => ({ error: item.error, idx }))
      .sort((a, b) => a.error - b.error);

    let i = 0;
    while (diff > 0 && i < sorted.length) {
      items[sorted[i].idx].gridCol += 1;
      diff--;
      i++;
    }
  } else if (diff < 0) {
    // Subtract excess units from columns rounded up the most (1 by 1)
    const sorted = [...items]
      .map((item, idx) => ({ error: item.error, idx }))
      .sort((a, b) => b.error - a.error);

    let i = 0;
    while (diff < 0 && i < sorted.length) {
      const idx = sorted[i].idx;
      if (items[idx].gridCol > 1) {
        items[idx].gridCol -= 1;
        diff++;
      }
      i++;
      if (i >= sorted.length && diff < 0) {
        i = 0;
      }
    }
  }

  return items.map(({ error, ...col }) => col);
}

export function getVisibleFiltersMeta() {
  try {
    const stored = localStorage.getItem(WORKLIST_COLUMNS_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) {
        const merged = Array.from(new Set([...MANDATORY_WORKLIST_COLUMNS, ...parsed]));
        const filtered = filtersMeta.filter(col => merged.includes(col.name));
        if (filtered.length > 0) {
          return adjustGridCols(filtered);
        }
      }
    }
  } catch (err) {
    console.error('Error loading worklist columns from localStorage', err);
  }
  const defaultCols = filtersMeta.filter(col => DEFAULT_WORKLIST_COLUMNS.includes(col.name));
  return adjustGridCols(defaultCols);
}
